import { makeStyles } from '@material-ui/styles'

export default makeStyles(() => ({
  image: {
    width: '100%',
  },
}))
